import api from './api';

export const getDiscussions = (courseId, page = 1) => api.get(`/courses/${courseId}/discussions?page=${page}`);
export const getDiscussion = (courseId, id) => api.get(`/courses/${courseId}/discussions/${id}`);
export const createDiscussion = (courseId, data) => api.post(`/courses/${courseId}/discussions`, data);
export const replyToDiscussion = (discussionId, body) => api.post(`/discussions/${discussionId}/replies`, { body });
export const resolveDiscussion = (id) => api.patch(`/discussions/${id}/resolve`);